<div class="flex flex-1 flex-row-reverse relative px-6">
	<div class="flex-1">
		<button
			class="self-start"
			mat-stroked-button
			*ngIf="showBackToOverview"
			(click)="goToOverview()"
			[testHook]="testHooks.GoToOverviewButton"
		>
			&lt; Overview
		</button>
		<div class="flex flex-col">
			<div class="flex gap-4 pb-4 border-b border-grey-light">
				<h3 class="mb-0">Search Teranet</h3>
				<ui-button
					data-intercom-target="title-search-show-hide"
					preset="ICON_DEFAULT"
					[icon]="showSearch ? 'eye-off' : 'eye'"
					[label]="showSearch ? 'Hide Search' : 'Show Search'"
					(click)="toggleSearch()"
					[testHook]="testHooks.Button"
				></ui-button>
			</div>
			<div [@openCloseWithState]="showSearch ? 'open' : 'closed'">
				<div class="flex border-b border-grey-light py-4 gap-6">
					<div class="flex flex-col">
						<span class="-my-2">Select Your Preferred Search Criterion</span>
						<app-radio-group
							labelOrientation="row"
							[items]="titleSearchHolders"
							name="titleSearchHolders"
							(ngModelChange)="onChangeSearchCriteria($event)"
							[ngModel]="selectedSearchType"
							type="compact"
							[testHook]="testHooks.TitleSearchHoldersRadioGroup"
						></app-radio-group>
					</div>
					<app-sale-lro class="self-end" [required]="true"></app-sale-lro>
				</div>
				<div class="mt-1">
					<app-button
						btn="link"
						[icon]="ICON.FILE"
						(onClick)="openFile()"
						*ngIf="lastestAPS?.url"
						class="float-right"
						[testHook]="testHooks.ViewApsButton"
					>
						View APS
					</app-button>
				</div>
			</div>
			<div class="flex flex-1 flex-col">
				<app-teranet-search-by-owner
					*ngIf="selectedSearchType === searchType.OWNER"
					[showSearch]="showSearch"
					[isOverview]="isOverview"
					class="flex flex-1 flex-col"
					(searchCompletedEvent)="onSearchCompleted($event)"
					(lroNotSelectedEvent)="onLroNotSelected($event)"
				></app-teranet-search-by-owner>
				<app-teranet-search-by-address
					*ngIf="selectedSearchType === searchType.ADDRESS"
					[showSearch]="showSearch"
					[isOverview]="isOverview"
					class="flex flex-1 flex-col"
					(searchCompletedEvent)="onSearchCompleted($event)"
				></app-teranet-search-by-address>
				<app-teranet-search-by-pin
					*ngIf="selectedSearchType === searchType.PIN"
					[showSearch]="showSearch"
					[isOverview]="isOverview"
					class="flex flex-1 flex-col"
					(searchCompletedEvent)="onSearchCompleted($event)"
				></app-teranet-search-by-pin>
				<app-teranet-search-by-instrument
					*ngIf="selectedSearchType === searchType.INSTRUMENT"
					[showSearch]="showSearch"
					[isOverview]="isOverview"
					class="flex flex-1 flex-col"
					(searchCompletedEvent)="onSearchCompleted($event)"
				></app-teranet-search-by-instrument>
			</div>
		</div>
	</div>
</div>
